// Counts code points of the NFKC form, as the server does: `String.length` counts an emoji twice.
export const getPasswordLength = (password: string): number =>
  [...password.normalize('NFKC')].length;
